import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroChecklistPipe } from '../pipes/filtro-checklist.pipe';

import { CheckCalibragemService } from '../services/check-calibragem.service';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ProfissionalService } from '../services/profissional.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';


@Component({
	selector: 'app-calibragem-pneus',
	templateUrl: './calibragem-pneus.component.html',
	styleUrls: ['./calibragem-pneus.component.css'],
	animations: [loadingFade, modal, alert]
})
export class CalibragemPneusComponent implements OnInit {

    //Id do menu da tb_menu
    public menu_id = 123; //checklist	

	public loading = false;
	public checklists = [];
	public veiculos = [];
	public unidades = [];
	public clientes = [];
	public profissionais = [];
	public periodos = [{ periodo: 'D', periodo_nome: 'Diurno' }, { periodo: 'N', periodo_nome: 'Noturno' }];
	public situacoes = [{ situacao: '1', situacao_nome: 'Ativo' }, { situacao: '0', situacao_nome: 'Inativo' }];
	public perfil = this.authSvc.getPerfil();

	public formFiltro: FormGroup;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public showFilter = false;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;
	public usuario_exibir_regiao;

	constructor(private fb: FormBuilder,
		private checkCalibragemSvc: CheckCalibragemService,
		private clienteSvc: ClienteService,
		private unidadeSvc: UnidadeService,
		private veiculoSvc: VeiculoService,
		private authSvc: AuthService,
		private route: ActivatedRoute,
		private router: Router,			
		private profissionalSvc: ProfissionalService ,
		private excelSvc: ExcelService,
		private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {


		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  


		//Verifica perfil de Acesso
		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {

			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.pegaChecklistsRegiao();
			}else{
				this.pegaChecklists();
			}

		}).catch((err) => {
		console.log(err);scrollBy
		}); 



		this.criaFiltro();
	}


	criaFiltro() {
		this.pegaClientes();
		this.pegaUnidades();
		//this.pegaVeiculos();

		this.formFiltro = this.fb.group({
			cliente_id___cliente: null,
			unidade_id___unidade: null,
			veiculo_id___veiculo: null,
			check_calibragem_turno___periodo: null,
			check_calibragem_status___status: null,
			check_calibragem_data___data_i: null,
			check_calibragem_data___data_f: null,
			profissional_id___profissional: null
		});

		let campos_data = ['check_calibragem_data___data_i', 'check_calibragem_data___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}


		this.route.params.subscribe( params => {

			if(params.id){

				let splitF = params.id.split("&");

				let loCliente_id = null;
				let loUnidade_id = null;
				let loVeiculo_id = null;
				let loTipoVeiculo_id = null;
				let loPeriodo_id = null;
				let loData_i = "";
				let loData_f = "";
				let loProfissional_id = null;

				//this.showFilter = false;

				for (var i = 0; i < splitF.length; i++) {

					var loSplitValor = splitF[i].split("=");

					switch(loSplitValor[0]) { 
						case "cliente_id___cliente": { 

							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loCliente_id = parseInt(loSplitValor[1]);
								this.pegaUnidadesFiltro(loSplitValor[1]);
							}
						   break; 

						} 
						case "unidade_id___unidade": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loUnidade_id = parseInt(loSplitValor[1]);
								this.pegaVeiculosEProfissionalFiltro(loUnidade_id,loCliente_id);
							}

						  break; 
						}
						case "veiculo_id___veiculo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
						   		loVeiculo_id = parseInt(loSplitValor[1]);
							}
						   break; 
						} 
						case "check_calibragem_turno___periodo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loPeriodo_id = loSplitValor[1];
							}
							break; 
						}  
						case "check_calibragem_data___data_i": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								let splitDate1 = loSplitValor[1].split("-");
								if(splitDate1){
									loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
								}
							}
						   break; 
						}      
						case "check_calibragem_data___data_f": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								let splitDate1 = loSplitValor[1].split("-");
								if(splitDate1){
									loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
								}
							}
						   break; 
						}      
						case "profissional_id___profissional": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
						   		loProfissional_id =  parseInt(loSplitValor[1]);
							}
						   break; 
						}                                                      
					 }

				}
				this.preencheForm({
					cliente_id___cliente: loCliente_id,
					unidade_id___unidade: loUnidade_id,
					veiculo_id___veiculo: loVeiculo_id,
					check_calibragem_turno___periodo: loPeriodo_id,
					check_calibragem_status___status: null, // nao esta sendo usado?
					check_calibragem_data___data_i: loData_i,
					check_calibragem_data___data_f: loData_f,
					profissional_id___profissional: loProfissional_id									

				});
				this.filtra();

			}

		});

	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
  	}

	pegaUnidadesFiltro(cliente_id){
		if(cliente_id){
			this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
				this.unidades = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});
		}
	}

	pegaChecklists() {
		this.checklists = [];
		this.loading = true;

		this.checkCalibragemSvc.getCheckCalibragemByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.checklists = data;
			this.count = this.checklists.length;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}

	pegaChecklistsRegiao() {
		this.checklists = [];
		this.loading = true;

		this.checkCalibragemSvc.getCheckCalibragemByRegiao(this.authSvc.getUsuarioId()).then((data: any) => {
			this.checklists = data;
			this.count = this.checklists.length;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}


	pegaClientes() {
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	pegaUnidades() {
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	onChangeCliente(evento) {
		this.formFiltro.controls.unidade_id___unidade.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroChecklistPipe().transform(this.checklists, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}

	apagaChecklist(id) {
		Swal.fire({
			type: 'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'

		}).then((result) => {
			if (result.value == true) {
				if (this.authSvc.getPerfil() == 2) {
					this.checkCalibragemSvc.apagaCheckCalibragemAdmin(id).then((data) => {
						this.pegaChecklists();
						Swal.fire({
							type: 'success',
							title: 'Apagado com sucesso!'
						});
					}).catch((err) => {
						console.log(err);
						Swal.fire({
							type: 'error',
							title: 'Ops! Algo de errado aconteceu!',
							text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
						});
					});
				}
				else {
					this.checkCalibragemSvc.apagaCheckCalibragem(id).then((data) => {
						this.pegaChecklists();
						Swal.fire({
							type: 'success',
							title: 'Apagado com sucesso!'
						});
					}).catch((err) => {
						console.log(err);
						Swal.fire({
							type: 'error',
							title: 'Ops! Algo de errado aconteceu!',
							text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
						});
					});
				}

			}
		});
	}

	exportarExcel() {
		let data = [];
		if (this.dadosFiltrados.length == 0) {
			this.dadosFiltrados = this.checklists;
		}

		for (let index in this.dadosFiltrados) {
			data[index] = {
				'Data do Turno': moment(this.dadosFiltrados[index].check_calibragem_data).format('DD/MM/YYYY'),
				'Central': this.dadosFiltrados[index].cliente.cliente_nome,
				'Unidade': this.dadosFiltrados[index].unidade.unidade_nome,
				'Periodo': this.dadosFiltrados[index].check_calibragem_turno == 'D' ? 'Diurno' : 'Noturno',
				'Veículo': this.dadosFiltrados[index].veiculo.veiculo_placa,
				'Profissional': this.dadosFiltrados[index].profissional.profissional_nome,
				'Data/hora de gravação': moment(this.dadosFiltrados[index].check_calibragem_registro).format('DD/MM/YYYY HH:mm:ss'),
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Checklists');
	}

	expandPanel() {
		this.showFilter = this.showFilter == true ? false : true;
	}

	print(id) {
		let url = location.href.split('#')[0] + '#' + '(print:print/checkcalibragem/' + id + ')'
		window.open(url);
	}

	deletado(flag) {
		return flag == 'S' ? 'deletado' : '';
	}

	onChangeVeiculoUnidade(e){

		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"todos").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}


			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
	}

  pegaProfissionaisClienteUnidade(e){
		  this.loading = true;
		
		  this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
			this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	

	  onClickLimparCampos(){
		this.criaFiltro();
	  }

	  EditCalibragemPneus(check_calibragem_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		this.router.navigate(['home/calibragempneus/edit/' + check_calibragem_id + params]);
	}


	VerCalibragemPneus(check_calibragem_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		this.router.navigate(['home/calibragempneus/ver/' + check_calibragem_id + params]);
	}	
	
	
	pegaVeiculosEProfissionalFiltro(unidade_id,cliente_id){

		if(typeof unidade_id === 'undefined'){
			return "";
		}else{
		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: unidade_id,
				cliente_id: cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
		}
	}

	pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(cliente_id,unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	

}
